/**
 * Formats YYYY-MM-DD (API date) for display using Shipment Tracker settings.
 */
export function formatShipmentDate(
  isoDate: string | null | undefined,
  dateFormat: string,
): string {
  if (!isoDate) return '';
  const [y, m, d] = isoDate.split('-');
  if (!y || !m || !d) return isoDate;

  switch (dateFormat) {
    case 'MM/DD/YYYY':
      return `${m}/${d}/${y}`;
    case 'YYYY-MM-DD':
      return `${y}-${m}-${d}`;
    case 'DD/MM/YYYY':
    default:
      return `${d}/${m}/${y}`;
  }
}
